// extracted by mini-css-extract-plugin
export default {"root":"r4OX7l","TextOnlyMenuButtonNSkin":"xTjc1A","textOnlyMenuButtonNSkin":"xTjc1A","linkElement":"UiHgGh","wrapper":"yRj2ms","label":"JS76Uv"};